import { Component, Element, Prop, h } from '@stencil/core';

import { defaultCenter, injectGoogleMapSDK, markerStyle, markerStyleSecondary } from '../../../utils/util.google-map';

@Component({
  tag: 'google-map',
  styleUrl: 'google-map.css',
  shadow: true,
})
export class GoogleMap {
  @Element() el: HTMLElement;
  @Prop() whenClicked: (index: number) => void = () => {};
  @Prop() dealerMarkers = [];
  @Prop() secondaryDealerMarkers = [];

  private infoWindowOpening = null;

  render() {
    return <div id="google-map-container" class="w-full mb-4 p-px"></div>;
  }

  componentDidLoad() {
    this.initMap();
  }

  async initMap() {
    await injectGoogleMapSDK();
    let centerLatLng = null;
    if (this.dealerMarkers.length === 1) {
      const lat = parseFloat(this.dealerMarkers[0].latitude);
      const lng = parseFloat(this.dealerMarkers[0].longitude);
      centerLatLng = new google.maps.LatLng(lat, lng);
    } else {
      centerLatLng = defaultCenter;
    }
    const mapOptions = {
      zoom: 8,
      center: centerLatLng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoomControl: true,
    };
    const root = this.el.shadowRoot.getElementById('google-map-container');
    const map = new google.maps.Map(root, mapOptions);

    if (this.secondaryDealerMarkers.length > 0) {
      const startIndex = this.dealerMarkers?.length || 0;
      this.secondaryDealerMarkers.forEach((secondaryMarker, index) => {
        const marker = new google.maps.Marker({
          map,
          position: new google.maps.LatLng(parseFloat(secondaryMarker.latitude), parseFloat(secondaryMarker.longitude)),
          // eslint-disable-next-line
          icon: markerStyleSecondary as any,
          label: {
            text: `${startIndex + index + 1}`,
            fontWeight: '600',
            color: '#225eaa',
          },
        });

        marker.addListener('click', () => {
          if (this.infoWindowOpening !== null) {
            this.infoWindowOpening.close();
            this.infoWindowOpening = null;
          }
          const gmiwElm = document.createElement('google-map-info-window');
          gmiwElm.dealerName = secondaryMarker.dealerName;
          gmiwElm.address = secondaryMarker.dealerAddress;
          gmiwElm.dealershipCity = secondaryMarker.dealershipCity;
          gmiwElm.dealershipState = secondaryMarker.dealershipState;
          gmiwElm.dealershipZipCode = secondaryMarker.dealershipZipCode;
          gmiwElm.distance = secondaryMarker.distance;
          gmiwElm.specChosen = secondaryMarker.specChosen;
          gmiwElm.index = startIndex + index;
          gmiwElm.whenClicked = this.whenClicked;

          this.infoWindowOpening = new google.maps.InfoWindow({
            content: gmiwElm,
          });

          this.infoWindowOpening.open({
            map,
            anchor: marker,
          });
        });
      });
    }

    this.dealerMarkers.forEach((dealerMarker, index) => {
      const marker = new google.maps.Marker({
        map,
        position: new google.maps.LatLng(parseFloat(dealerMarker.latitude), parseFloat(dealerMarker.longitude)),
        // eslint-disable-next-line
        icon: markerStyle as any,
        label: {
          text: `${index + 1}`,
          fontWeight: '600',
          color: '#fff',
        },
      });

      marker.addListener('click', () => {
        if (this.infoWindowOpening !== null) {
          this.infoWindowOpening.close();
          this.infoWindowOpening = null;
        }
        const gmiwElm = document.createElement('google-map-info-window');
        gmiwElm.dealerName = dealerMarker.dealerName;
        gmiwElm.address = dealerMarker.dealerAddress;
        gmiwElm.dealershipCity = dealerMarker.dealershipCity;
        gmiwElm.dealershipState = dealerMarker.dealershipState;
        gmiwElm.dealershipZipCode = dealerMarker.dealershipZipCode;
        gmiwElm.distance = dealerMarker.distance;
        gmiwElm.specChosen = dealerMarker.specChosen;
        gmiwElm.index = index;
        gmiwElm.whenClicked = this.whenClicked;

        this.infoWindowOpening = new google.maps.InfoWindow({
          content: gmiwElm,
        });

        this.infoWindowOpening.open({
          map,
          anchor: marker,
        });
      });
    });

    const bounds = new google.maps.LatLngBounds();

    if (this.dealerMarkers.length > 0) {
      this.dealerMarkers.forEach((dealerMarker) => {
        bounds.extend({
          lat: parseFloat(dealerMarker.latitude),
          lng: parseFloat(dealerMarker.longitude),
        });
      });
    }
    if (this.secondaryDealerMarkers.length > 0) {
      this.secondaryDealerMarkers.forEach((secondaryMarker) => {
        bounds.extend({
          lat: parseFloat(secondaryMarker.latitude),
          lng: parseFloat(secondaryMarker.longitude),
        });
      });
    }
    if (this.dealerMarkers.length > 0 || this.secondaryDealerMarkers.length > 0) {
      setTimeout(() => {
        map.fitBounds(bounds);
      }, 200);
    }
  }
}
